import { sqliteTable, text, integer, real } from "drizzle-orm/sqlite-core";
import { accounts } from "./accounts";

// ============================================================================
// tax_templates — Template ภาษี (VAT 7%, WHT, etc.)
// ============================================================================
export const taxTemplates = sqliteTable("accounting_tax_templates", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  name: text("name").notNull(),
  rate: real("rate").notNull(),
  taxType: text("tax_type", {
    enum: ["no_tax", "tax_inclusive", "tax_exclusive"],
  }).notNull(),
  // ภ.พ.30 classification — drives which section ของใบแบบ a line posts to:
  //   standard            → ช่อง 6: เสียภาษี 7% (normal VAT sales)
  //   zero_rated_export   → ช่อง 3: ส่งออก 0%
  //   zero_rated_domestic → ช่อง 4: ขายในประเทศ 0% (BOI, LPG, ฯลฯ)
  //   exempt              → ช่อง 5: ยกเว้น VAT (ม.81)
  taxCategory: text("tax_category", {
    enum: ["standard", "zero_rated_export", "zero_rated_domestic", "exempt"],
  }).notNull().default("standard"),
  taxScope: text("tax_scope", {
    enum: ["sale", "purchase", "all"],
  }).notNull().default("all"),
  taxAccountId: text("tax_account_id").references(() => accounts.id), // FK → accounts
  isDefault: integer("is_default").notNull().default(0),
  // System-seeded rows (from seedAccountingData) get is_system=1 so the UI can
  // render the "ระบบ" badge and the DELETE handler can block removal with 409.
  // Default 0 — user-created rows are deletable. See issue #344.
  isSystem: integer("is_system").notNull().default(0),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

// Type exports
export type TaxTemplate = typeof taxTemplates.$inferSelect;
export type NewTaxTemplate = typeof taxTemplates.$inferInsert;
